// extracted by mini-css-extract-plugin
module.exports = {"container":"SubSectionWrapperStyles_container__3aRfN","wrapper":"SubSectionWrapperStyles_wrapper__2YOiL"};